"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("path", {
    d: "M354.4,187.6v-22.3c0.1-24.6-19.8-44.7-44.4-44.8c-0.1,0-0.1,0-0.2,0h-44.4"
  }), (0, _core.jsx)("path", {
    d: "M269.2,65.8L221,113.7c-4.1,4.1-4.1,10.6-0.1,14.7c0,0,0,0,0.1,0.1l48.3,48.1c4.3,4,11,3.8,15-0.4c1.8-1.9,2.8-4.4,2.9-7.1 V73.3c0.3-5.7-4.2-10.6-9.9-10.9C274.3,62.2,271.3,63.5,269.2,65.8z"
  }), (0, _core.jsx)("circle", {
    cx: "155.8",
    cy: "167.9",
    r: "47.3"
  }), (0, _core.jsx)("path", {
    d: "M156.4,238.9c-47.1-0.2-87.1,34.4-93.7,81c-0.9,6.5,3.6,12.5,10.1,13.4c0.5,0.1,1,0.1,1.6,0.1h163.8 c6.6-0.1,11.8-5.4,11.8-12c0-0.5,0-1.1-0.1-1.6C243.2,273.5,203.4,238.9,156.4,238.9z"
  }), (0, _core.jsx)("circle", {
    cx: "343.3",
    cy: "272.2",
    r: "47.3"
  }), (0, _core.jsx)("path", {
    d: "M343.9,343.1c-47.1-0.2-87.1,34.4-93.8,81c-0.9,6.5,3.6,12.5,10.1,13.4c0.5,0.1,1,0.1,1.6,0.1h163.8 c6.6-0.1,11.8-5.4,11.8-12c0-0.5,0-1.1-0.1-1.6C430.7,377.6,390.9,343.1,343.9,343.1z"
  }));
};

exports.default = _default;